<template>
  <v-card>
    <notifications group="inviteUser" position="top center" />
    <v-card-title>
      <span class="headline">Invite a new user</span>
    </v-card-title>
    <small>*An invited user will not be added on table</small>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <!-- <v-flex xs4>
            <v-select
              v-model="Form.portalID"
              :items="portallist"
              item-text="portalName"
              item-value="id"
              attach
              chips
              multiple
              label="Portals"
              class="select-container"
            ></v-select>
          </v-flex> -->
          <v-flex xs4>
            <v-text-field
              v-model="Form.firstName"
              v-validate="'required'"
              data-vv-rules="required"
              data-vv-scope="inviteForm"
              :error-messages="errors.collect('inviteForm.firstName')"
              hide-details
              :counter="50"
              label="First Name*"
              name="firstName"
            />
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model="Form.lastName"
              v-validate="'required'"
              data-vv-rules="required"
              data-vv-scope="inviteForm"
              :error-messages="errors.collect('inviteForm.lastName')"
              hide-details
              :counter="50"
              label="Last Name*"
              name="lastName"
            />
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model="Form.userEmail"
              v-validate="'required'"
              data-vv-rules="required"
              data-vv-scope="inviteForm"
              :error-messages="errors.collect('inviteForm.userEmail')"
              hide-details
              :counter="50"
              label="User Email*"
              name="userEmail"
            />
          </v-flex>
          <v-flex xs4>
            <v-select
              v-model="Form.userLevel"
              v-validate="'required'"
              :items="lookupList('userlevel')"
              data-vv-rules="required"
              data-vv-scope="inviteForm"
              :error-messages="errors.collect('inviteForm.userLevel')"
              hide-details
              item-text="text"
              item-value="id"
              label="User Level*"
              name="userLevel"
            ></v-select>
          </v-flex>

          <v-flex xs6>
            <v-select
              v-if="switchToSponsor() == true"
              v-model="Form.sponsorID"
              v-validate="'required'"
              data-vv-rules="required"
              data-vv-scope="inviteForm"
              :error-messages="errors.collect('inviteForm.sponsorID')"
              name="sponsorID"
              :items="sponsors"
              item-text="name"
              item-value="id"
              chips
              label="Sponsors"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" flat @click.native="CloseDialog()">Cancel</v-btn>
      <v-btn color="blue darken-1" flat @click.native="SendInvitation('inviteForm')">Send invitation</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import axios from "axios";

export default {
  props: {
    settings: {
      type: Object,
      default() {
        return {};
      }
    },
    formaction: {
      type: String,
      default: ""
    },
    form: {
      handler: function() {
        if (this.form.portalID) {
          this.Form.portalID = this.form.portalID;
        }
        if (this.form.isSponsor) {
          this.Form.isSponsor = this.form.isSponsor;
        }
        if (this.form.firstName) {
          this.Form.firstName = this.form.firstName;
        }
        if (this.form.lastName) {
          this.Form.lastName = this.form.lastName;
        }
        if (this.form.userLevel) {
          this.Form.userLevel = this.form.userLevel;
        }
        if (this.form.userEmail) {
          this.Form.userEmail = this.form.userEmail;
        }
        if (this.form.sponsorID) {
          this.Form.sponsorID = this.form.sponsorID;
        }
      },
      deep: true
    },
    portallist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    Form: {
     confirmPin: null,
      emailDomain: null,
      emailVerificationCode: null,
      emailVerified: null,
      firstName: null,
      fullName: null,
      isSponsor: null,
      language: null,
      lastName: null,
      organisationID: null,
      password: null,
      passwordResetCode: null,
      portalID: [],
      sponsorID: null,
      userEmail: null,
      userID: null,
      userLevel: null
    },
    sponsors: []
  }),
  watch: {
    form() {
      this.Form = this.form;
    },
    Documents: {
      handler: function() {
        this.sponsors = this.Documents;
      },
      immediate: true,
      deep: true
    }
    // Form: {
    //   handler: function() {},
    //   deep: true
    // }
  },
  mounted() {
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
    this.readDocuments();
    this.Form.portalID = this.portal.active.id;
  },
  computed: {
    ...mapGetters({
      lookupList: "portal/lookupList",
      lookupListField: "portal/lookupListField"
    }),
    ...mapState({
      portal: state => state.portal,
      Documents: state => state.Admin.Documents,
      FirebaseFunctionsURL: state => state.FirebaseFunctionsURL,
      user: state => state.user.active
    }),
    sponsorLevel() {
      return this.lookupListField("userlevel", "10", "value", "id");
    }
  },
  methods: {
    switchToSponsor() {
      if (this.Form.userLevel == this.sponsorLevel) {
        this.Form.isSponsor = true;
        //console.log("isSponsor = " + this.Form.isSponsor);
        return true;
      } else {
        this.Form.isSponsor = false;
        return false;
      }
    },
    readDocuments() {
      this.$store.dispatch("Admin/readDocuments", [
        "sponsors",
        this.portal.active.id,
        "Admin/setDocuments"
      ]);
    },
    CloseDialog() {
      this.$emit("inviteUserDialog", false);
    },
    SendInvitation(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (!valid) {
          Vue.notify({
            group: "inviteUser",
            title: "Warning",
            text: "The fields must not be empty",
            type: "warning"
          });
        } else if (
          parseInt(this.user.userLevel) <
          parseInt(
            this.lookupListField(
              "userlevel",
              this.Form.userLevel,
              "id",
              "value"
            )
          )
        ) {
          Vue.notify({
            group: "inviteUser",
            title: "Warning",
            text: "You are not allowed to add an user above your user level",
            type: "warning"
          });
        } else {
          if (this.Form.isSponsor == true) {
            axios
              .get(
                this.FirebaseFunctionsURL +
                  "sendUserInvite?firstName=" +
                  this.Form.firstName +
                  "&lastName=" +
                  this.Form.lastName +
                  "&userEmail=" +
                  this.Form.userEmail +
                  "&userLevel=" +
                  this.Form.userLevel +
                  "&portalID=" +
                  this.portal.active.id +
                  "&isSponsor=" +
                  this.Form.isSponsor +
                  "&sponsorID=" +
                  this.Form.sponsorID +
                  "&inviteSenderName=" +
                  this.user.fullName
              )
              .then(response => {
                //console.log("RESULT: " + JSON.stringify(response, null, 2));
                //console.log(response.data.result);
                if (response.data.result === true) {
                  Vue.notify({
                    group: "inviteUser",
                    title: "Success",
                    text: "Invitation sent",
                    type: "success"
                  });
                  //this.$Console.log("Email sent");
                } else {
                  Vue.notify({
                    group: "inviteUser",
                    title: "Error",
                    text: "The invitation was not sent",
                    type: "error"
                  });
                }
              });
          } else {
            axios
              .get(
                this.FirebaseFunctionsURL +
                  "sendUserInvite?firstName=" +
                  this.Form.firstName +
                  "&lastName=" +
                  this.Form.lastName +
                  "&userEmail=" +
                  this.Form.userEmail +
                  "&userLevel=" +
                  this.Form.userLevel +
                  "&portalID=" +
                  this.portal.active.id +
                  "&isSponsor=" +
                  this.Form.isSponsor +
                  "&inviteSenderName=" +
                  this.user.fullName
              )
              .then(response => {
                //console.log("RESULT: " + JSON.stringify(response, null, 2));
                //console.log(response.data.result);
                if (response.data.result === true) {
                  Vue.notify({
                    group: "inviteUser",
                    title: "Success",
                    text: "Invitation sent",
                    type: "success"
                  });
                } else {
                  Vue.notify({
                    group: "inviteUser",
                    title: "Error",
                    text: "The invitation was not sent",
                    type: "error"
                  });
                }
              });
          }
          this.CloseDialog();
        }
      });
    }
  }
};
</script>

<style>
.form {
  width: 900px;
  border-radius: 10px !important;
}
</style>